import { render, staticRenderFns } from "./FormatList.vue?vue&type=template&id=4238067c&"
import script from "./FormatList.vue?vue&type=script&lang=js&"
export * from "./FormatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4238067c')) {
      api.createRecord('4238067c', component.options)
    } else {
      api.reload('4238067c', component.options)
    }
    module.hot.accept("./FormatList.vue?vue&type=template&id=4238067c&", function () {
      api.rerender('4238067c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/FormatList.vue"
export default component.exports